import * as marietta3d from '..';
import { Geometry } from './utils';
import * as marietta from '../../marietta';
// import Point = marietta.core.Point;
// import Line = marietta3d.AutoGen.utils.RoomEdge;
// import PointArray = marietta3d.AutoGen.utils.RoomPointArray;
// import Geometry = marietta3d.AutoGen.utils.Geometry;
// import AutoObjRoom = marietta3d.AutoGen.object.AutoObjRoom;
// import AutoObjWall = marietta3d.AutoGen.object.AutoObjWall;
// import AutoObjDimension = marietta3d.AutoGen.object.AutoObjDimension;
// import ALMOST_ZERO = marietta3d.AutoGen.utils.ALMOST_ZERO;
// import RC_INCLP = marietta3d.AutoGen.utils.RC_INCLP;
// import HTYPE = marietta3d.AutoGen.object.HTYPE;

export default class AutoHallway {
        private autoBase: marietta3d.AutoGen.AutoBase;

        private Geom: marietta3d.AutoGen.utils.Geometry;

        /*------------------------------------------------------
        * constructor
        */
        constructor(base: marietta3d.AutoGen.AutoBase) {
          this.autoBase = base;
          this.Geom = new marietta3d.AutoGen.utils.Geometry();
        }

        /*------------------------------------------------------
        * 廊下自動生成
        */
        public AGHallway(flr: number) {
          this.AddHeyaMinMax(flr); // MinMaxを廊下として追加
          this.CutKeisan(flr); // 全部屋で相互にカット（indexで優先順位を判断）
          this.CutRoukaByKaidan(flr); // 階段で廊下をカット
          this.autoBase.HeyaPointAdd(flr); // 他の部屋の頂点を、接続する部屋に追加
          this.RoukaDelete(flr); // 不要な廊下を削除
          this.autoBase.InitWallList(); // 全壁削除
          for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
            this.autoBase.MakeWallHeya(this.autoBase.HeyaList[flr - 1][i]);
          }
        }

        /*------------------------------------------------------
        * 玄関、階段に接続していない廊下を削除する
        *
        */
        private RoukaDelete(flr:number) {
          // すべての部屋のマークをクリア
          for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
            const h = this.autoBase.HeyaList[flr - 1][i];
            h.SetEnable(false);
          }
          /// 1階：玄関に接続する有効な廊下にマークをつける。
          /// 他の階：階段に接続する有効な廊下にマークを付ける
          this.RoukaDeleteSub(flr);
          // マークの付いていない廊下を削除する
          for (let cnt = 0; cnt < this.autoBase.HeyaList[flr - 1].length; cnt += 1) {
            const heya = this.autoBase.HeyaList[flr - 1][cnt];
            if (heya.IsHallway() === true) {
              if (heya.GetEnable() === false) { // マークを確認
                this.autoBase.HeyaList[flr - 1].splice(cnt, 1);
                cnt -= 1;
              }
            }
          }
        }

        /*------------------------------------------------------
        * 1階   ：玄関に接続する有効な廊下にマークをつける。
        * 他の階：階段に接続する有効な廊下にマークを付ける
        */
        private RoukaDeleteSub(flr:number) {
          const same = [];
          if (flr === 1) {
            /* 廊下 玄関 */
            this.autoBase.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.ENTRANCE, same);
            AutoHallway.SetRoukaExist(same);
          } else {
            /* 廊下 階段 */
            this.autoBase.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.STAIR, same);
            AutoHallway.SetRoukaExist(same);
          }
          /* 廊下 廊下 */
          same.splice(0, same.length);
          this.autoBase.PickupHeyaType(flr, marietta3d.AutoGen.object.HTYPE.HALLWAY, marietta3d.AutoGen.object.HTYPE.HALLWAY, same);
          AutoHallway.SetRoukaExistContinue(same);
        }

        /*------------------------------------------------------
        * 廊下にマークをつける。
        *
        */
        private static SetRoukaExist(same:Array<marietta3d.AutoGen.object.AutoObjWall>) {
          for (let i = 0; i < same.length; i += 1) {
            const kb = same[i];
            if (kb.htypeLeft >= 0) {
              const h = kb.leftHeya;
              if (h.HeyaType() === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
                h.SetEnable(true);
              }
            }
            if (kb.htypeRight >= 0) {
              const h = kb.rightHeya;
              if (h.HeyaType() === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
                h.SetEnable(true);
              }
            }
          }
        }

        /*------------------------------------------------------
        * 廊下にマークをつける。(廊下どうしの接続チェック)
        * (false -> true)があった場合は、最初からやり直し
        */
        private static SetRoukaExistContinue(same: Array<marietta3d.AutoGen.object.AutoObjWall>) {
          let change = true;
          while (change) {
            change = false;
            for (let i = 0; i < same.length; i += 1) {
              const kb = same[i];
              if ((kb.htypeLeft >= 0) && (kb.htypeRight >= 0)) {
                const h1 = kb.leftHeya;
                const h2 = kb.rightHeya;

                if (h1.GetEnable() === true) {
                  if (h2.GetEnable() === false) {
                    h2.SetEnable(true);
                    change = true;
                  }
                } else if (h2.GetEnable() === true) {
                  if (h1.GetEnable() === false) {
                    h1.SetEnable(true);
                    change = true;
                  }
                }
              }
            }
          }
        }

        /*------------------------------------------------------
        * 部屋のＭｉｎＭａｘを取り、最大の部屋を追加
        */
        private AddHeyaMinMax(flr:number) {
          if (this.autoBase.HeyaList[flr - 1].length === 0) {
            // 部屋が一つも無い。
            return;
          }
          const min = new marietta.core.Point(0, 0, 0);
          const max = new marietta.core.Point(0, 0, 0);
          let first = true;
          for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
            const heya1 = this.autoBase.HeyaList[flr - 1][i];
            if ((heya1.IsPorch() === false) && (heya1.IsBalcony() === false)) {
              if (first === true) {
                heya1.points.GetPolygonMinMax(min, max);
                first = false;
              } else {
                heya1.points.GetPolygonMinMaxAdd(min, max);
              }
            }
          }
          if (max.x === 0) {
            // 該当階に居室が一つも無い。
            return;
          }
          const plg = new marietta3d.AutoGen.utils.RoomPointArray();
          plg.Add(new marietta.core.Point(min.x, max.y, 1));
          plg.Add(new marietta.core.Point(min.x, min.y, 1));
          plg.Add(new marietta.core.Point(max.x, min.y, 1));
          plg.Add(new marietta.core.Point(max.x, max.y, 1));
          const h1 = new marietta3d.AutoGen.object.AutoObjRoom('rom02_01', '廊下', 1, marietta.webcad.WebCADGlobal.getGuid(), plg, flr);
          h1.visible = true;
          this.autoBase.InsertHeyaTop(h1);
        }

        /*------------------------------------------------------
        *
        * カットによって新たに追加される領域を、元の部屋と同じ属性で追加する
        *
        */
        private CutKeisanAddNewHeya(heya1: marietta3d.AutoGen.object.AutoObjRoom, plg: marietta3d.AutoGen.utils.RoomPointArray, backup: marietta3d.AutoGen.utils.RoomPointArray, cut: marietta3d.AutoGen.utils.RoomPointArray) {
          const ary = new marietta3d.AutoGen.utils.RoomPointArray();
          ary.CopyFrom(heya1.points);
          const newHeya = new marietta3d.AutoGen.object.AutoObjRoom(heya1.item, heya1.name, heya1.index, marietta.webcad.WebCADGlobal.getGuid(), ary, heya1.flr); /* 元の部屋のコピー */
          newHeya.points.RemoveAll();
          newHeya.points.CopyFrom(plg); /* 新たな囲みをセットする */
          newHeya.points.SetFlag(1);
          Geometry.CopyNonVisible(backup, newHeya.points); /* 元の部屋の囲みから、開口部分をコピーする */
          Geometry.CopyNonVisible(cut, newHeya.points);
          newHeya.index += 1; /* インデックス番号を＋１する */
          for (let j = 0; j < this.autoBase.HeyaList[heya1.flr - 1].length; j += 1) {
            const h = this.autoBase.HeyaList[heya1.flr - 1][j];
            if (h.index >= newHeya.index) {
              h.index += 1;
            }
          }
          for (let i = 0; i < this.autoBase.HeyaList[heya1.flr - 1].length; i += 1) {
            const h = this.autoBase.HeyaList[heya1.flr - 1][i];
            if (h.index > newHeya.index) {
              this.autoBase.HeyaList[heya1.flr - 1].splice(i, 0, newHeya);
              break;
            }
          }
        }

        /*------------------------------------------------------
        *
        * カットによって変形した囲みを元の部屋の囲みにセットする
        *
        */
        private static CutKeisanHeyaModify(heya1: marietta3d.AutoGen.object.AutoObjRoom, plg: marietta3d.AutoGen.utils.RoomPointArray, backup: marietta3d.AutoGen.utils.RoomPointArray, cut: marietta3d.AutoGen.utils.RoomPointArray) {
          heya1.points.RemoveAll();
          heya1.points.CopyFrom(plg); /* 新たな囲みをセットする */
          heya1.points.SetFlag(1);

          Geometry.CopyNonVisible(backup, heya1.points);
          Geometry.CopyNonVisible(cut, heya1.points);
        }

        /*------------------------------------------------------
        *
        * カットする部屋(heya2)がカットされる部屋(heya1)に含まれるので、
        * カットされる部屋(heya1)を分割してからカットする
        *
        *（注意：部屋が分割されたときに index がズレるので壁からのサーチは禁止）
        */
        private CutKeisanHeyaDivide(heya1: marietta3d.AutoGen.object.AutoObjRoom, heya2: marietta3d.AutoGen.object.AutoObjRoom) {
          const backup = new marietta3d.AutoGen.utils.RoomPointArray();
          backup.CopyFrom(heya1.points);
          const line = new marietta3d.AutoGen.utils.RoomPointArray();
          this.Geom.PolygonToLine(heya1.points, line, true); /* カットされる部屋を線分に分解する */
          const p1 = heya2.points[0]; /* カットする部屋の第1辺を分割ラインとする */
          const p2 = heya2.points[1];
          const cr = new marietta3d.AutoGen.utils.RoomPointArray(); /* 分割後の線分を格納する配列 */
          heya1.points.IsIncludeLineAtPolygon(p1, p2, cr, true, marietta3d.AutoGen.utils.ALMOST_ZERO, true, false);
          if (cr.length > 0) {
            cr.CopyTo(line);
          }
          const list:any = new marietta3d.AutoGen.utils.RoomPointArray();
          this.Geom.BuildPolygon(line, list, true); /* 分割後の線分から多角形を再構成する(複数あるはず) */
          let cnt = 0;
          const cutPlg = heya2.points;
          let obj: any;
          for (let i = 0; i < list.length; i += 1) {
            obj = list[i];
            const clist:any = new marietta3d.AutoGen.utils.RoomPointArray();
            const ret2 = cutPlg.CutPolygonByPolygon(obj, clist);
            if (ret2 === obj.RC_INCLP.AWAY || ret2 === obj.RC_INCLP.OUTSIDE_CONTACT) {
              if (cnt === 0) {
                AutoHallway.CutKeisanHeyaModify(heya1, obj, backup, cutPlg);
              } else {
                this.CutKeisanAddNewHeya(heya1, obj, backup, cutPlg);
              }
              cnt += 1;
            } else {
              let obj2: any;
              for (let j = 0; j < clist.length; j += 1) {
                obj2 = clist[j];
                if (cnt === 0) {
                  AutoHallway.CutKeisanHeyaModify(heya1, obj2, backup, cutPlg);
                } else {
                  this.CutKeisanAddNewHeya(heya1, obj2, backup, cutPlg);
                }
                cnt += 1;
              }
            }
          }
        }

        /*------------------------------------------------------
        *
        * 部屋１を部屋２でカットする。
        * 部屋１が削除されるとき false を返す
        *
        *（注意：部屋が分割されたときに index がズレるので壁からのサーチは禁止）
        */
        private CutKeisanMain(heya1: marietta3d.AutoGen.object.AutoObjRoom, heya2: marietta3d.AutoGen.object.AutoObjRoom) {
          /* 2つの部屋囲みの幾何学的な関係を調べる */
          const plg1 = heya1.points;
          const plg2 = heya2.points;
          const ret = plg1.IsIncludePolygon(plg2);
          if (ret === marietta3d.AutoGen.utils.RC_INCLP.AWAY || ret === marietta3d.AutoGen.utils.RC_INCLP.OUTSIDE_CONTACT) {
            /*     0:領域が離れている,       3:接している(外接(点接触を含む)) */
            return true;
          }
          if (ret === marietta3d.AutoGen.utils.RC_INCLP.SAME || ret === marietta3d.AutoGen.utils.RC_INCLP.INCLUDE_BY_B || ret === marietta3d.AutoGen.utils.RC_INCLP.INCLUDE_BY_B_CONTACT) {
            /*     1:同一領域,               6:ＡがＢに含まれる,           7:ＡがＢに含まれる(内接(点接触を含む)) */

            /* 部屋１を削除 */
            return false;
          } if (ret === marietta3d.AutoGen.utils.RC_INCLP.INCLUDE_BY_A) { /* 4:ＢがＡに含まれる */
            /* カットする領域のすべてががカットされる領域に含まれるので */
            /* カットされる領域を分割してからカットする（「穴」を作らない為） */
            this.CutKeisanHeyaDivide(heya1, heya2);
            return true;
          }
          /* 部屋１を部屋２でカットする */
          const backup = new marietta3d.AutoGen.utils.RoomPointArray();
          backup.CopyFrom(plg1);
          let cnt = 0;
          const list = [];
          const ret2 = plg2.CutPolygonByPolygon(plg1, list); /* 部屋1を部屋2でカットする */
          if (ret2 === marietta3d.AutoGen.utils.RC_INCLP.AWAY || ret2 === marietta3d.AutoGen.utils.RC_INCLP.OUTSIDE_CONTACT) {
            return true;
          }
          let obj2: any;
          for (let i = 0; i < list.length; i += 1) {
            obj2 = list[i];
            if (cnt === 0) {
              AutoHallway.CutKeisanHeyaModify(heya1, obj2, backup, plg2);
            } else {
              this.CutKeisanAddNewHeya(heya1, obj2, backup, plg2);
            }
            cnt += 1;
          }

          return true;
        }

        /*------------------------------------------------------
        *
        */
        public CutKeisan(flr:number) {
          // すべての部屋を反時計回りにする
          for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
            const heya1 = this.autoBase.HeyaList[flr - 1][i];
            if (heya1.IsStair() === false) { // 階段室以外
              // heya1.point.RemoveSamePoint();
              // heya1.point.RemoveOnlinePoint();
              heya1.points.GetPolygonLeftTurn(1);
            }
          }
          for (let loop = 0; loop < this.autoBase.HeyaList[flr - 1].length; loop += 1) {
            const heya1 = this.autoBase.HeyaList[flr - 1][loop];
            if (heya1.IsStair() === false) {
              for (let loop2 = 0; loop2 < this.autoBase.HeyaList[flr - 1].length; loop2 += 1) {
                if (loop !== loop2) {
                  const heya2 = this.autoBase.HeyaList[flr - 1][loop2];
                  if ((heya1.index <= heya2.index) && (this.CutKeisanMain(heya1, heya2) === false) && !heya2.IsStair()) {
                    if (heya1.index <= heya2.index) {
                      // if (heya2.IsStair()) continue;
                      // 部屋１を部屋２でカットする
                      // if (this.CutKeisan_Main(heya1, heya2) == false) {
                      // 部屋１を削除
                      this.autoBase.HeyaList[flr - 1].splice(loop, 1);
                      loop -= 1;
                      // }
                    }
                  }
                }
              }
            }
          }
        }

        /*------------------------------------------------------
        * 廊下を階段でカットする
        *
        */
        public CutRoukaByKaidan(flr:number) {
          for (let loop = 0; loop < this.autoBase.HeyaList[flr - 1].length; loop += 1) {
            const heya1 = this.autoBase.HeyaList[flr - 1][loop];
            if (heya1.IsHallway()) { // 廊下に対してのみ
              for (let loop2 = 0; loop2 < this.autoBase.HeyaList[flr - 1].length; loop2 += 1) {
                if (loop !== loop2) {
                  const heya2 = this.autoBase.HeyaList[flr - 1][loop2];
                  if (heya2.IsStair() === true) { // 階段でカットする
                    const plg = new marietta3d.AutoGen.utils.RoomPointArray();
                    heya2.points.CopyTo(plg);
                    const CutPlg = new marietta3d.AutoGen.object.AutoObjRoom(heya2.item, heya2.name, heya2.index, marietta.webcad.WebCADGlobal.getGuid(), plg, heya2.flr);
                    CutPlg.points.GetPolygonLeftTurn(1);
                    // 部屋１を部屋２でカットする
                    if (this.CutKeisanMain(heya1, CutPlg) === false) {
                      // 部屋１を削除
                      this.autoBase.HeyaList[flr - 1].splice(loop, 1);
                      loop -= 1;
                    }
                  }
                }
              }
            }
          }
        }
}
